// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3272Y","emails":"CreateEditClinics_emails__3yaF7","emailTagLabel":"CreateEditClinics_emailTagLabel__3JA9g"};